import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import IconButton from 'material-ui/IconButton';
import DescriptionIcon from '@material-ui/icons/Description';
import { dataEntryPaths } from '../utils/globals';

const DataEntryLink = (props) => {
  const { dataEntryKey } = props;
  const arr = dataEntryKey.split('__');
  let dePath = dataEntryPaths[arr[0]];
  if (arr.length > 1) dePath = dePath.replace(':id', arr[1]);

  return (
    <Link to={`${dePath}`}>
      <IconButton aria-label="Form" color="primary">
        <DescriptionIcon />
      </IconButton>
    </Link>
  );
};

DataEntryLink.propTypes = {
  // customer_id: PropTypes.string.isRequired,
  dataEntryKey: PropTypes.string.isRequired,
};

export default DataEntryLink;



// WEBPACK FOOTER //
// ./src/components/DataEntryLink.jsx